import actionTypes from '../actions/reports/actionType';

const initialState = {
  handoverReportsLoading: false,
  handoverReports: {},
  amountList: [],
  dutyListLoading: false,
  dutyList: [],
  baseBusinessReportLoading: false,
  baseBusinessIncomeList: [],
  paymentTypeList: [],

  redundListLoading: false,
  refundList: [],
  refundListTotal: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_HANDOVER_REPORTS_LOADING:
      const { handoverReportsLoading } = payload;
      return {
        ...state,
        handoverReportsLoading,
      };
    case actionTypes.INIT_HANDOVER_REPORTS:
      const { handoverReports } = payload;
      return {
        ...state,
        handoverReports,
      };
    case actionTypes.RESET_HANDOVER_REPORTS:
      return {
        ...state,
        handoverReports: {},
        amountList: [],
      };
    case actionTypes.INIT_AMOUNT_LIST:
      const { amountList } = payload;
      return {
        ...state,
        amountList,
      };
    case actionTypes.SET_DUTY_LIST_LOADING:
      const { dutyListLoading } = payload;
      return {
        ...state,
        dutyListLoading,
      };
    case actionTypes.INIT_DUTY_LIST:
      const { dutyList } = payload;
      return {
        ...state,
        dutyList,
      };
    case actionTypes.UPDATE_REPORT_STATE:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.REPORT_BAS_BUSINESS:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.REPORT_RECEPTION:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.REPORT_CARD:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.REPORT_BALANCE:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.MEMBER_CARD_DETAIL:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.SET_CROSS_NA_REFUND_LIST_LOADING:
      const { redundListLoading } = payload;
      return {
        ...state,
        redundListLoading,
      };
    case actionTypes.INIT_CROSS_NA_REFUND_LIST:
      const { refundList } = payload;
      return {
        ...state,
        refundList,
      };
    case actionTypes.SET_CROSS_NA_REFUND_LIST_TOTAL:
      const { refundListTotal } = payload;
      return {
        ...state,
        refundListTotal,
      };
    case actionTypes.UPDATE_CROSS_NA_REFUND_LIST:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
